import gql from 'graphql-tag'
import { getProvider } from '@/apollo'
import { splitError } from '@/helper/splitError'

const initialState = {
  paymentType: 'bankAccount',
  bankAccount: {
    iban: '',
    accountHolder: '',
    confirmation: false
  },
  validationStatus: '',
  backendErrorCode: null,
  backendErrorMessage: null
}

const CheckoutPaymentModule = {
  namespaced: true,
  state: initialState,
  getters: {
    paymentType: state => state.paymentType,
    bankAccount: state => {
      return state.bankAccount
    },
    paymentContext: (state, getters, rootState, rootGetters) => {
      return {
        firstName: rootGetters['checkout/personalData/firstName'],
        lastName: rootGetters['checkout/personalData/lastName'],
        email: rootGetters['checkout/personalData/email'],
        address: rootGetters['checkout/personalData/address']
      }
    },
    payment: (state, rootGetters) => {
      return {
        ownerFirstName: rootGetters['checkout/personalData/firstName'],
        ownerLastName: rootGetters['checkout/personalData/lastName'],
        owner: state.bankAccount?.accountHolder,
        iban: state.bankAccount?.iban,
        paymentType: state.paymentType
      }
    },
    validationStatus: state => state.validationStatus,
    backendErrorCode: state => state.backendErrorCode,
    backendErrorMessage: state => state.backendErrorMessage
  },
  actions: {
    async validateAndSavePayment ({ commit, dispatch, state, getters, rootGetters, rootState }, { paymentType, bankAccount, nextStep }) {
      commit('clearMessages', {}, { root: true })
      commit('SET_VALIDATION_STATUS', 'STARTED')
      commit('SET_BACKEND_ERROR_CODE', null)
      commit('SET_BACKEND_ERROR_MESSAGE', null)
      commit('SET_PAYMENT_TYPE', paymentType)
      commit('SET_PAYMENT_BANK_ACCOUNT', bankAccount)

      const apolloClient = getProvider().defaultClient

      // build payment type input for validation
      let vPaymentType = null

      // for bank account payment
      if (paymentType === 'bankAccount') {
        vPaymentType = {
          iban: bankAccount.iban,
          owner: bankAccount.accountHolder,
          paymentType: paymentType
        }
      }

      // get tariff from checkout module
      const validatePaymentInput = {
        ...rootGetters['checkout/personalData/validateAddressCore'],
        address: rootGetters['checkout/personalData/address'],
        paymentType: vPaymentType
      }

      return apolloClient.mutate({
        mutation: gql`mutation checkout ($validatePaymentInput: ValidatePaymentInput!) {
          validatePayment (validatePayment: $validatePaymentInput){
            success
          }
        }`,
        variables: {
          validatePaymentInput: validatePaymentInput
        }
      }).then((response) => {
        if (response.data.validatePayment.success) {
          commit('SET_VALIDATION_STATUS', 'SUCCESS')
          commit('checkout/goToStep', nextStep, { root: true })
        } else {
          commit('SET_VALIDATION_STATUS', 'FAILED')
        }
      }).catch((error) => {
        let errorCode = 500
        let errorMessage = 'Es ist ein technischer Fehler aufgetreten.'

        // get error code and message
        if (splitError(error)[0].extensions.magma_code) {
          errorCode = splitError(error)[0].extensions.magma_code
        }
        if (splitError(error)[0].message) {
          errorMessage = splitError(error)[0].message
        }

        // if it's not a technical error, validation failed
        if (errorCode === 500) {
          commit('SET_VALIDATION_STATUS', 'ERROR')
        } else {
          commit('SET_VALIDATION_STATUS', 'FAILED')
        }

        // build error message
        if (errorMessage.indexOf(errorCode) === -1) {
          errorMessage = errorMessage + ' (Fehler: ' + errorCode + ')'
        }

        // update state
        commit('SET_BACKEND_ERROR_CODE', errorCode)
        commit('SET_BACKEND_ERROR_MESSAGE', errorMessage)

        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    resetPaymentDefaultState ({ commit, state }) {
      // initialize
      commit('clearMessages', {}, { root: true })
      commit('resetState', state)
    }
  },
  mutations: {
    SET_PAYMENT_TYPE (state, paymentType) {
      state.paymentType = paymentType
    },
    SET_PAYMENT_BANK_ACCOUNT (state, bankAccount) {
      state.bankAccount = bankAccount
    },
    SET_VALIDATION_STATUS (state, status) {
      state.validationStatus = status
    },
    SET_BACKEND_ERROR_CODE (state, code) {
      state.backendErrorCode = code
    },
    SET_BACKEND_ERROR_MESSAGE (state, code) {
      state.backendErrorMessage = code
    },
    resetState (state) {
      Object.assign(state, initialState)
    }
  }
}

export default CheckoutPaymentModule
